// import { QRCode } from 'react-qrcode-logo';

// export const downloadQRCode = (eventId) => {
//     const qrCodeCanvas = document.createElement('canvas');
//     const qrCode = (
//         <QRCode 
//             value={`https://eventmgmtapp1.web.app/ATTENDANCE/${eventId}`} 
//             size={200} 
//             logoImage="/path/to/logo.png"
//             renderAs="canvas" 
//             canvasRef={qrCodeCanvas}
//         />
//     );
    
//     const downloadLink = document.createElement('a');
//     downloadLink.href = qrCodeCanvas.toDataURL("image/png");
//     downloadLink.download = `event-${eventId}-qr.png`;
//     downloadLink.click();
// };
import React, { useRef, useEffect } from 'react';
import { QRCode } from 'react-qrcode-logo';
import ReactDOM from 'react-dom';
import logo from './ov--new.png';
const QRCodeGenerator = ({ eventId, onRendered }) => {
    const qrRef = useRef(null);

    useEffect(() => {
        // Call the onRendered callback after mounting
        console.log("Logo path:", logo);
        if (onRendered) onRendered(qrRef);
    }, [onRendered]);

    return (
        <div ref={qrRef} style={{ display: 'none' }}>
            <QRCode 
    value={`${window.location.origin}/attendance/${eventId}`} 
    size={200} 
    logoImage={logo}
    logoWidth={50}      // Adjust these values as needed
    logoHeight={50}
    removeQrCodeBehindLogo={true} // Clear QR code behind the logo
    logoPaddingStyle="circle"
    renderAs="canvas" 
/>

        </div>
    );
};

export const downloadQRCodeWrapper = (eventId) => {
    const wrapperDiv = document.createElement('div');
    document.body.appendChild(wrapperDiv);

    const handleRendered = (qrRef) => {
        const qrCanvas = qrRef.current.querySelector('canvas');
        if (qrCanvas) {
            const downloadLink = document.createElement('a');
            downloadLink.href = qrCanvas.toDataURL("image/png");
            downloadLink.download = `event-${eventId}-qr.png`;
            downloadLink.click();
        } else {
            console.error("QR code canvas not found.");
        }
        document.body.removeChild(wrapperDiv); // Clean up after download
    };

    ReactDOM.render(
        <QRCodeGenerator eventId={eventId} onRendered={handleRendered} />, 
        wrapperDiv
    );
};

export default QRCodeGenerator;
